module.exports = __webpack_public_path__ + "img/hero-gamer-oni.45d55268.png";